import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Orthopedics, Fellowship - Sports Medicine",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "ACL Reconstruction Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - Orthopedics, DNB - Orthopedics",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Sports Injury Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Orthopedics, MCh - Orthopedic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Arthroscopic ACL Surgery Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MS - Orthopedics, Fellowship - Arthroscopy",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive ACL Repair"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Orthopedics, MCh - Sports Medicine",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced ACL Reconstruction"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MS - Orthopedics, Fellowship - Knee Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Revision ACL Surgery Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>ACL Tear Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for ACL tears with advanced reconstruction techniques for optimal recovery and return to sports.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const ACLTearTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced ACL Tear Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            ACL Reconstruction with 95% Success Rate. Restore Knee Stability and Return to Sports with Precision Surgery.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Sports Injury Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Surgical Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>6-9</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Return to Sports</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-2</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "rehabilitation", label: "Rehab", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "❓" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>ACL Tear Treatment</span>
            </h2>
          </div>

          {/* What is ACL Tear */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding ACL Tears
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                An ACL (Anterior Cruciate Ligament) tear is one of the most common knee injuries, particularly 
                among athletes. The ACL is a key ligament that helps stabilize your knee joint by connecting 
                your thigh bone (femur) to your shin bone (tibia). When the ACL is torn, it often causes 
                significant knee instability and can lead to further joint damage if not properly treated.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>ACL Function</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Prevents forward movement of tibia, provides rotational stability, and works with other 
                      ligaments to maintain proper knee alignment during movement and weight-bearing activities.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Causes</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Sudden stops or changes in direction, awkward landings from jumps, direct knee collisions, 
                      and pivoting motions during sports like soccer, basketball, and skiing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Symptoms & Diagnosis */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Symptoms & Diagnosis of ACL Tears
            </h3>

            <div className="row">
              {[
                {
                  title: "Popping Sound/Sensation", 
                  description: "Audible or felt 'pop' in the knee at the time of injury, often followed by immediate pain",
                  details: "Classic symptom reported by 70% of patients"
                },
                {
                  title: "Severe Pain & Swelling", 
                  description: "Rapid swelling within hours of injury due to bleeding in the joint",
                  details: "Swelling typically peaks within 24 hours"
                },
                {
                  title: "Knee Instability", 
                  description: "Feeling of knee 'giving way' during weight-bearing activities or sudden movements",
                  details: "Primary indication for surgical intervention"
                },
                {
                  title: "Loss of Range of Motion", 
                  description: "Difficulty fully straightening or bending the knee due to pain and swelling",
                  details: "May require pre-surgery physical therapy"
                },
                {
                  title: "Tenderness & Bruising", 
                  description: "Pain along joint line and visible bruising around the knee developing over days",
                  details: "Indicates associated soft tissue damage"
                },
                {
                  title: "Difficulty Walking", 
                  description: "Inability to bear weight on affected leg or walk without limping",
                  details: "May require crutches initially"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ACL Tear Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of ACL Tears & Injuries
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Grade 1 Sprain",
                    description: "Mild stretching of ACL fibers without tearing, minimal instability",
                    treatment: "Conservative treatment with physical therapy, bracing"
                  },
                  {
                    type: "Grade 2 Sprain",
                    description: "Partial tear of ACL with moderate instability and functional limitation",
                    treatment: "May require surgery depending on activity level and instability"
                  },
                  {
                    type: "Grade 3 Tear",
                    description: "Complete rupture of ACL with significant knee instability",
                    treatment: "Surgical reconstruction recommended for active individuals"
                  },
                  {
                    type: "Isolated ACL Tear",
                    description: "ACL injury without damage to other knee structures",
                    treatment: "Better prognosis, simpler surgical approach"
                  },
                  {
                    type: "Combined Ligament Injury",
                    description: "ACL tear with damage to MCL, LCL, or meniscus (common)",
                    treatment: "Complex reconstruction addressing all damaged structures"
                  },
                  {
                    type: "ACL Avulsion Fracture",
                    description: "ACL tears off with piece of bone from tibial attachment",
                    treatment: "Bone fragment reattachment, common in children"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Risk Factors & Prevention */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Risk Factors & Prevention Strategies
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Participation in cutting and pivoting sports</li>
                      <li style={{ marginBottom: "10px" }}>Female athletes (2-8 times higher risk)</li>
                      <li style={{ marginBottom: "10px" }}>Previous ACL injury</li>
                      <li style={{ marginBottom: "10px" }}>Poor neuromuscular control</li>
                      <li>Improper landing and cutting techniques</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Prevention Strategies</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Neuromuscular training programs</li>
                      <li style={{ marginBottom: "10px" }}>Proper landing technique education</li>
                      <li style={{ marginBottom: "10px" }}>Strength training for hamstrings and glutes</li>
                      <li style={{ marginBottom: "10px" }}>Plyometric exercises</li>
                      <li>Sport-specific conditioning</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Conservative treatment may be appropriate for patients with partial tears, low activity 
                    levels, or those who cannot undergo surgery due to medical reasons.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Conservative Treatments:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Physical therapy and rehabilitation</li>
                          <li style={{ marginBottom: "8px" }}>Bracing for stability</li>
                          <li style={{ marginBottom: "8px" }}>Activity modification</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Strength training programs</li>
                          <li style={{ marginBottom: "8px" }}>Pain management</li>
                          <li style={{ marginBottom: "8px" }}>Lifestyle adjustments</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Candidates for Non-Surgical Treatment:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Partial tears with minimal instability</li>
                      <li style={{ marginBottom: "8px" }}>Sedentary lifestyle patients</li>
                      <li style={{ marginBottom: "8px" }}>Medical contraindications to surgery</li>
                      <li>Elderly patients with low activity demands</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical ACL Reconstruction
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedure:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Arthroscopic minimally invasive approach</li>
                      <li style={{ marginBottom: "10px" }}>Graft harvest from patient's own tissue</li>
                      <li style={{ marginBottom: "10px" }}>Precision tunnel placement in bone</li>
                      <li style={{ marginBottom: "10px" }}>Graft fixation with screws or buttons</li>
                      <li>1-2 hour procedure under anesthesia</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Graft Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Patellar tendon autograft (gold standard)</li>
                      <li style={{ marginBottom: "10px" }}>Hamstring tendon autograft</li>
                      <li style={{ marginBottom: "10px" }}>Quadriceps tendon autograft</li>
                      <li style={{ marginBottom: "10px" }}>Allograft (cadaver tissue)</li>
                      <li>Synthetic graft materials</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Computer-assisted navigation</li>
                      <li style={{ marginBottom: "10px" }}>Anatomical reconstruction</li>
                      <li style={{ marginBottom: "10px" }}>Double-bundle technique</li>
                      <li>Enhanced recovery protocols</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Pain and swelling management", "Crutch use with partial weight-bearing", "Basic range of motion exercises", "Wound care"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Early Rehabilitation",
                    activities: ["Gradual weaning off crutches", "Progressive strength training", "Improved range of motion", "Balance exercises"]
                  },
                  {
                    period: "Month 2-4",
                    title: "Intermediate Phase",
                    activities: ["Full weight-bearing", "Advanced strength training", "Light jogging begins", "Sport-specific drills"]
                  },
                  {
                    period: "Month 6-9",
                    title: "Return to Sports",
                    activities: ["Full strength achieved", "Sport-specific training", "Gradual return to competition", "Final functional testing"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Rehabilitation Protocol */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Comprehensive Rehabilitation Protocol
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Early Phase (0-6 weeks)</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Pain and swelling control</li>
                      <li style={{ marginBottom: "10px" }}>Restore full knee extension</li>
                      <li style={{ marginBottom: "10px" }}>Quadriceps activation</li>
                      <li>Gradual weight-bearing progression</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Phase (3-6 months)</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Strength and endurance training</li>
                      <li style={{ marginBottom: "10px" }}>Plyometric exercises</li>
                      <li style={{ marginBottom: "10px" }}>Sport-specific drills</li>
                      <li>Agility and cutting movements</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How long does it take to recover from ACL surgery?",
                  answer: "Recovery from ACL reconstruction is a gradual process that typically takes 6-9 months for return to sports, though the timeline varies based on individual factors. In the first 2 weeks, focus is on pain control and basic mobility. By 6 weeks, most patients can walk without crutches. At 3 months, light jogging may begin. Between 4-6 months, sport-specific training intensifies. Most athletes are cleared for full return to sports between 6-9 months after passing functional tests. However, complete recovery and optimal strength may take up to 12 months. The recovery process requires strict adherence to physical therapy and gradual progression through rehabilitation phases. Rushing the process increases re-injury risk, while proper rehabilitation maximizes long-term success and reduces the likelihood of future knee problems."
                },
                {
                  question: "What is the best graft choice for ACL reconstruction?",
                  answer: "The 'best' graft choice depends on individual factors including age, activity level, sport demands, and surgeon expertise. The patellar tendon autograft (BTB) is often called the 'gold standard' due to its excellent strength and bone-to-bone healing, making it ideal for high-demand athletes. However, it has a higher risk of anterior knee pain. Hamstring tendon autografts offer less donor site morbidity and are popular for recreational athletes, though they may have slightly higher re-tear rates in young athletes. Quadriceps tendon autografts are gaining popularity as they provide good strength with minimal donor site issues. Allografts (cadaver tissue) are used for revision surgeries or older patients but have higher failure rates in young active individuals. Your orthopedic surgeon will recommend the most appropriate graft based on your specific circumstances, goals, and their surgical experience."
                },
                {
                  question: "Can an ACL tear heal without surgery?",
                  answer: "A completely torn ACL cannot heal on its own because the torn ends retract and the ligament lacks blood supply. However, some patients may function well without surgery through conservative management. Non-surgical treatment is considered for: Partial ACL tears with minimal instability; Patients with sedentary lifestyles; Those with medical contraindications to surgery; Older patients with low activity demands. Conservative treatment focuses on physical therapy to strengthen surrounding muscles (especially hamstrings), improve proprioception, and modify activities to avoid instability episodes. While this approach can provide functional stability for daily activities, it typically doesn't allow return to cutting and pivoting sports. Without surgical reconstruction, there's an increased risk of meniscal damage and early arthritis due to recurrent instability episodes. The decision between surgical and non-surgical management should be made in consultation with an orthopedic specialist."
                },
                {
                  question: "What is the success rate of ACL reconstruction surgery?",
                  answer: "ACL reconstruction has a high success rate, with approximately 85-95% of patients achieving good to excellent results. Success is typically defined as restored knee stability, return to pre-injury activity level, and patient satisfaction. Several factors influence success rates: Surgical technique and graft choice; Patient age and activity level; Compliance with rehabilitation; Timing of surgery (optimal is after swelling resolves and range of motion returns). The re-tear rate is approximately 5-10%, with higher rates in young athletes returning to high-risk sports. Long-term studies show that 80-90% of patients return to sports, though some may not reach their pre-injury performance level. Proper rehabilitation is crucial - patients who complete their physical therapy program have significantly better outcomes. While ACL reconstruction successfully restores stability, it doesn't fully prevent future arthritis, which emphasizes the importance of ongoing knee care and maintenance exercises."
                },
                {
                  question: "When can I return to sports after ACL surgery?",
                  answer: "Return to sports after ACL reconstruction is typically allowed between 6-9 months post-surgery, but this timeline must be individualized. Several criteria must be met before clearance: Full range of motion compared to uninjured knee; Quadriceps and hamstring strength at least 90% of uninjured side; No pain or swelling with activities; Successful completion of sport-specific drills; Passing functional tests (hop tests, agility drills). The return process is gradual: Light jogging at 3-4 months; Sport-specific drills at 4-6 months; Non-contact practice at 6-8 months; Full competition at 8-9 months or later. Rushing return increases re-injury risk by 4-6 times. Psychological readiness is also important - fear of re-injury can affect performance. Your surgeon and physical therapist will use objective measurements and functional tests to determine when you're truly ready for safe return to sports at your desired level."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Restore Knee Stability?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert orthopedic surgeons provide advanced ACL reconstruction for optimal recovery and return to active lifestyle.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Sports Medicine: <strong>080-6541-7705</strong> | Orthopedic Surgery: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default ACLTearTreatment;